import {Component} from 'react'

import Date from '../../../shared/components/Moment/Date.jsx'
import Clock from 'react-feather/dist/icons/clock.js'

import './Moderations.scss'

export default class ModerationsLoaded extends Component {
  render() {
    return (
      <ul className="moderations">
        {
          this.props.history.map((history) => {
            return (
              <li className="d-flex align-items-center" key={history.id}>
                <div className="moderations-icon">
                  <Clock size={12} />
                </div>

                <div className="moderations-item bg-gray-100 flex-fill px-4 py-3 radius-lg">
                  <em>#{history.id}</em>
                  <strong>{history.moderator ? history.moderator.fullname : 'n/a'}</strong>
                  <p>{history.description}</p>
                  <time dateTime={history.created_at}>
                    <Date format="dd/MM/yyyy HH:mm" date={history.created_at} />
                  </time>
                </div>
              </li>
            )
          })
        }
      </ul>
    )
  }
}
